export default "__VITE_ASSET__CTqdodir__"